type IconProps = {
  className?: string
}

export function NewsPlayerIconPlay({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
    >
      <path
        transform="translate(4, 3.5)"
        d="M0.000565154 0.41738C0.000565134 0.0966297 0.347787 -0.10384 0.625565 0.0565353L7.02531 3.75143C7.30309 3.9118 7.30309 4.31274 7.02531 4.47312L0.625565 8.16801C0.347788 8.32838 0.000565629 8.12792 0.000565609 7.80717L0.000565154 0.41738Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function NewsPlayerIconPlayLarge({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="19"
      height="24"
      viewBox="0 0 19 24"
      fill="none"
      aria-hidden
    >
      <path
        d="M1.16602 1.1665L17.4993 11.6665L1.16602 22.1665V1.1665Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export function NewsPlayerIconPause({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 24 24"
      aria-hidden
    >
      <path fill="currentColor" d="M6 5h4v14H6V5zm8 0h4v14h-4V5z" />
    </svg>
  )
}

export function NewsPlayerIconVolumeOn({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
    >
      <path
        fill="currentColor"
        d="M8.00039 3C7.43435 3 7.30372 3.3325 7.30372 3.3325C7.30372 3.3325 5.99747 4.9 5.12664 5.6125C4.90893 5.755 4.69122 5.85 4.38643 5.85H3.64622C3.21081 5.85 2.77539 6.325 2.77539 6.8V8.7C2.77539 9.175 3.21081 9.65 3.64622 9.65H4.38643C4.69122 9.65 4.90893 9.745 5.03956 9.8875C5.91039 10.6 7.30372 12.1675 7.30372 12.1675C7.30372 12.1675 7.43435 12.5 7.95685 12.5C8.39227 12.5 8.82768 12.025 8.82768 11.55V3.95C8.82768 3.475 8.39227 3 7.95685 3H8.00039ZM11.3531 3.95H11.0483L10.6129 4.9V5.1375C11.4837 5.945 12.0062 6.5625 12.0062 7.845C12.0062 9.08 11.5708 9.745 10.7 10.5525C10.5693 10.5525 10.5693 10.695 10.6129 10.79L11.0483 11.5975H11.3531C12.5287 10.5525 13.2254 9.46 13.2254 7.7975C13.2254 6.135 12.5287 5.0425 11.3531 3.9975V3.95ZM11.4837 7.75C11.4837 6.705 11.0483 6.23 10.3952 5.565H10.1775L9.65497 6.3725V6.705C10.0904 7.085 10.3081 7.18 10.3081 7.7975C10.3081 8.415 10.0904 8.51 9.65497 8.89V9.175L10.0904 9.8875L10.2646 9.9825H10.3952C11.0483 9.175 11.4837 8.7 11.4837 7.75Z"
      />
    </svg>
  )
}

export function NewsPlayerIconVolumeOff({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
    >
      <path
        fill="currentColor"
        d="M8.00039 3C7.43435 3 7.30372 3.3325 7.30372 3.3325C7.30372 3.3325 5.99747 4.9 5.12664 5.6125C4.90893 5.755 4.69122 5.85 4.38643 5.85H3.64622C3.21081 5.85 2.77539 6.325 2.77539 6.8V8.7C2.77539 9.175 3.21081 9.65 3.64622 9.65H4.38643C4.69122 9.65 4.90893 9.745 5.03956 9.8875C5.91039 10.6 7.30372 12.1675 7.30372 12.1675C7.30372 12.1675 7.43435 12.5 7.95685 12.5C8.39227 12.5 8.82768 12.025 8.82768 11.55V3.95C8.82768 3.475 8.39227 3 7.95685 3H8.00039Z"
      />
      <path
        stroke="currentColor"
        strokeWidth="1.15"
        strokeLinecap="round"
        d="M10.75 6.5L13.25 9.5"
      />
      <path
        stroke="currentColor"
        strokeWidth="1.15"
        strokeLinecap="round"
        d="M13.25 6.5L10.75 9.5"
      />
    </svg>
  )
}

export function NewsPlayerIconSettings({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
    >
      <path
        fill="currentColor"
        d="M14.2432 6.936C13.103 6.65075 12.5623 5.34525 13.1668 4.33812C13.4486 3.86913 13.3638 3.46488 13.0846 3.18663L12.8134 2.91537C12.5352 2.63712 12.1309 2.55225 11.6619 2.83312C10.6539 3.43775 9.34834 2.897 9.064 1.75687C8.93184 1.22575 8.58534 1 8.19159 1H7.80841C7.41466 1 7.069 1.22575 6.936 1.75687C6.65075 2.897 5.34525 3.43775 4.33812 2.83312C3.86913 2.55138 3.464 2.63625 3.18575 2.9145L2.9145 3.18575C2.63625 3.464 2.55138 3.86913 2.83312 4.33812C3.43775 5.34613 2.897 6.65159 1.75687 6.936C1.2275 7.06809 1 7.41375 1 7.80841V8.19159C1 8.58534 1.22575 8.931 1.75687 9.064C2.897 9.34925 3.43775 10.6547 2.83312 11.6619C2.55138 12.1309 2.63625 12.5352 2.91537 12.8134L3.18663 13.0846C3.46575 13.3638 3.87088 13.4478 4.33812 13.1668C5.34613 12.5623 6.65159 13.103 6.936 14.2432C7.06809 14.7743 7.41466 15 7.80841 15H8.19159C8.58534 15 8.931 14.7743 9.064 14.2432C9.34925 13.103 10.6547 12.5623 11.6619 13.1668C12.13 13.4478 12.5343 13.3638 12.8134 13.0846L13.0846 12.8134C13.3628 12.5352 13.4478 12.1309 13.1668 11.6619C12.5623 10.6539 13.103 9.34834 14.2432 9.064C14.7743 8.93184 15 8.58534 15 8.19159V7.80841C15 7.41375 14.7725 7.06809 14.2432 6.936ZM8 10.625C6.55013 10.625 5.375 9.44984 5.375 8C5.375 6.55013 6.55013 5.375 8 5.375C9.44984 5.375 10.625 6.55013 10.625 8C10.625 9.44984 9.44984 10.625 8 10.625Z"
      />
    </svg>
  )
}

const PIP_ICON_SCALE = 13 / 11
const PIP_ICON_OFFSET_X = (16 - 13 * PIP_ICON_SCALE) / 2
const PIP_ICON_OFFSET_Y = (16 - 11 * PIP_ICON_SCALE) / 2

export function NewsPlayerIconPip({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
    >
      <g
        transform={`translate(${PIP_ICON_OFFSET_X}, ${PIP_ICON_OFFSET_Y}) scale(${PIP_ICON_SCALE})`}
      >
        <path
          d="M11.9 0.5H1.1C0.768629 0.5 0.5 0.798477 0.5 1.16667V9.83333C0.5 10.2015 0.768629 10.5 1.1 10.5H11.9C12.2314 10.5 12.5 10.2015 12.5 9.83333V1.16667C12.5 0.798477 12.2314 0.5 11.9 0.5Z"
          stroke="currentColor"
        />
        <path
          d="M5.65 0.25H0.85C0.518629 0.25 0.25 0.569797 0.25 0.964286V4.53571C0.25 4.9302 0.518629 5.25 0.85 5.25H5.65C5.98137 5.25 6.25 4.9302 6.25 4.53571V0.964286C6.25 0.569797 5.98137 0.25 5.65 0.25Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.5"
          transform="translate(6, 5)"
        />
      </g>
    </svg>
  )
}

const FULLSCREEN_ICON_SCALE = 14 / 12
const FULLSCREEN_ICON_OFFSET = (16 - 12 * FULLSCREEN_ICON_SCALE) / 2

export function NewsPlayerIconFullscreen({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
    >
      <g
        transform={`translate(${FULLSCREEN_ICON_OFFSET}, ${FULLSCREEN_ICON_OFFSET}) scale(${FULLSCREEN_ICON_SCALE})`}
      >
        <path
          d="M1.5 4.5V1.5H4.5M7.5 1.5H10.5V4.5M1.5 7.5V10.5H4.5M7.5 10.5H10.5V7.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export function NewsPlayerIconLoading({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      aria-hidden
    >
      <path
        opacity="0.5"
        d="M15.9994 2.6665C13.3623 2.6665 10.7844 3.44849 8.59175 4.91358C6.3991 6.37866 4.69013 8.46104 3.68096 10.8974C2.67179 13.3337 2.40775 16.0146 2.92222 18.601C3.43669 21.1875 4.70656 23.5632 6.57126 25.4279C8.43597 27.2926 10.8117 28.5625 13.3982 29.077C15.9846 29.5914 18.6655 29.3274 21.1018 28.3182C23.5382 27.3091 25.6205 25.6001 27.0856 23.4074C28.5507 21.2148 29.3327 18.6369 29.3327 15.9998C29.3327 14.2489 28.9878 12.5151 28.3177 10.8974C27.6477 9.27972 26.6656 7.80986 25.4274 6.57175C24.1893 5.33363 22.7195 4.35151 21.1018 3.68144C19.4841 3.01138 17.7503 2.6665 15.9994 2.6665ZM15.9994 26.6665C13.8897 26.6665 11.8274 26.0409 10.0733 24.8688C8.31915 23.6968 6.95198 22.0309 6.14464 20.0818C5.33731 18.1327 5.12607 15.988 5.53765 13.9189C5.94922 11.8497 6.96512 9.94912 8.45688 8.45736C9.94864 6.9656 11.8493 5.9497 13.9184 5.53813C15.9875 5.12655 18.1322 5.33779 20.0813 6.14512C22.0304 6.95246 23.6963 8.31963 24.8684 10.0738C26.0404 11.8279 26.666 13.8902 26.666 15.9998C26.666 18.8288 25.5422 21.5419 23.5418 23.5423C21.5414 25.5427 18.8283 26.6665 15.9994 26.6665Z"
        fill="currentColor"
      />
      <path
        d="M26.5835 14.6699C26.6753 15.4006 27.2636 15.9998 28 15.9998C28.7364 15.9998 29.3402 15.4014 29.2667 14.6687C29.1369 13.3744 28.818 12.1036 28.3184 10.8974C27.6483 9.27972 26.6662 7.80986 25.4281 6.57175C24.19 5.33363 22.7201 4.35151 21.1024 3.68144C19.8962 3.18181 18.6254 2.86298 17.3311 2.73312C16.5984 2.6596 16 3.26346 16 3.99984C16 4.73622 16.5993 5.32457 17.3299 5.41636C19.6685 5.71018 21.8581 6.77304 23.5425 8.45736C25.2268 10.1417 26.2897 12.3313 26.5835 14.6699Z"
        fill="currentColor"
      />
    </svg>
  )
}
